import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import BenefitsSection from './components/BenefitsSection';
import CategoriesSection from './components/CategoriesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ArticlesSection from './components/ArticlesSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <TrustSection />
      <BenefitsSection />
      <CategoriesSection />
      <FAQSection />
      <CTASection />
      <ArticlesSection />
      <Footer />
    </main>
  );
}